"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _Checkbox = _interopRequireDefault(require("./Checkbox.styles"));
var _excluded = ["checked", "onChange", "className", "label"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Checkbox = function Checkbox(_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange,
    className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    props = _objectWithoutProperties(_ref, _excluded);
  // HOOKS
  var classes = (0, _Checkbox.default)();
  return /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    classes: {
      root: classes.labelRoot,
      label: classes.label
    },
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, _extends({
      className: (0, _classnames.default)(classes.root, className),
      classes: {
        checked: classes.checked,
        disabled: classes.disabled,
        indeterminate: classes.indeterminate
      },
      disableRipple: true,
      checked: checked,
      onChange: onChange
    }, props)),
    label: label
  });
};
var _default = Checkbox;
exports.default = _default;